import { removePrompt, removePromptFromGamePack } from '@/client/gamePacks';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface DeletePromptDialogProps {
  promptId?: string;
  gamePackPromptId?: string;

  isOpen: boolean;

  setIsOpen: (isOpen: boolean) => void;
  onSubmit?: () => void;
}

export const DeletePromptDialog = ({
  setIsOpen,
  isOpen,
  onSubmit,
  promptId,
  gamePackPromptId
}: DeletePromptDialogProps) => {
  const onDelete = async () => {
    if (!promptId) return;

    if (gamePackPromptId) {
      await removePromptFromGamePack(gamePackPromptId, promptId);
    } else {
      await removePrompt(promptId);
    }
    setIsOpen(false);
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle className="text-[24px] font-bold">Delete prompt</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {gamePackPromptId
            ? 'Are you sure you want to remove this prompt from this game pack?'
            : 'Are you sure you want to delete this prompt? You can not undo this action.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button className="btn btn-neutral secondary mr-[5px]" onClick={() => setIsOpen(false)}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={async () => onDelete()}>
          Delete
        </button>
      </DialogActions>
    </Dialog>
  );
};
